import { render, staticRenderFns } from "./sk-sidebar.vue?vue&type=template&id=6f2bd517"
import script from "./sk-sidebar.vue?vue&type=script&lang=js"
export * from "./sk-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports